// HOAD Vitrine de Recursos: sincroniza os pontinhos (mobile) com o carrossel
// horizontal por scroll nativo. Suporta múltiplas instâncias da seção na
// mesma página (cada grid tem seu próprio conjunto de dots ao lado).
(function () {
  function setup(grid) {
    var wrapper = grid.closest('.hoad-feature-showcase');
    var dots = wrapper ? wrapper.querySelector('[data-hoad-feature-dots]') : null;
    if (!dots) return;
    var dotEls = dots.querySelectorAll('.hoad-feature-showcase__dot');
    if (!dotEls.length) return;

    grid.addEventListener(
      'scroll',
      function () {
        var cards = grid.querySelectorAll('.hoad-feature-showcase__card');
        if (!cards.length) return;
        var cardWidth = cards[0].offsetWidth + 16;
        var index = Math.round(grid.scrollLeft / cardWidth);
        dotEls.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      },
      { passive: true }
    );
  }

  document.querySelectorAll('[data-hoad-feature-grid]').forEach(setup);
})();
